<div class="alert alert-danger m-0 text-center" role="alert">
  {{ message }}
</div>